import creditar from "./creditar";
import dashboardar from "./Dashboardar";
import docar from "./docar";
import helpar from "./helpar";
import invoicear from "./invoicear";
import offerar from "./offerar";
import ordersar from "./ordersar";
import productar from "./productar";
import supportar from "./supportar";
import promotionar from "./promotionar";
import reviewar from "./reviewar";
import deliveryar from "./deliveryar";
import issuesar from "./issuesar";
import reportsar from "./reportsar";
import invreportar from "./invreportar";
import receiptar from "./receiptar";
import notificationar from "./notificationar";
import assigndeliveryar from "./assigndeliveryar";
import driverar from "./driverar";
import suppliertrackar from "./suppliertrackar";
import dashboardhomear from "./dashboardhomear";
import popupar from "./popupar";
import bulkar from "./bulkar";
import profilear from "./profilear";
import categoryar from "./categoryar";
import productdetailsar from "./productdetailsar";
// import all arabic files

export default {
  ...creditar,
  ...dashboardar,
  ...docar,
  ...helpar,
  ...invoicear,
  ...offerar,
  ...ordersar,
  ...productar,
  ...supportar,
  ...promotionar,
  ...reviewar,
  ...deliveryar,
  ...issuesar,
  ...reportsar,
  ...invreportar,
  ...receiptar,
  ...notificationar,
  ...assigndeliveryar,
  ...driverar,
  ...suppliertrackar,
  ...dashboardhomear,
  ...popupar,
  ...bulkar,   
  ...profilear,
  ...categoryar,
  productdetailsar
};